import React from 'react';
import { Navbar, Form, InputGroup, Dropdown } from 'react-bootstrap';
import { Search, Menu, Bell, Settings, User, LogOut } from 'lucide-react';

const DashboardNavbar = ({ onToggleSidebar, onLogout }) => {
  return (
    <Navbar bg="white" className="navbar-dashboard border-bottom py-3 px-4">
      <div className="d-flex justify-content-between w-100 align-items-center">
        <div className="d-flex align-items-center">
          <button 
            className="btn btn-link d-md-none me-3 p-0" 
            onClick={onToggleSidebar}
          >
            <Menu size={24} />
          </button>
          <Form className="d-none d-md-flex">
            <InputGroup>
              <InputGroup.Text className="bg-transparent border-end-0">
                <Search size={18} />
              </InputGroup.Text>
              <Form.Control
                type="search"
                placeholder="Search"
                className="border-start-0 ps-0"
              />
            </InputGroup>
          </Form>
        </div>

        <div className="d-flex align-items-center">

          <Dropdown align="end">
            <Dropdown.Toggle variant="link" className="nav-link p-0 d-flex align-items-center">
              <User size={20} />
              <span className="ms-2 d-none d-md-inline">Account</span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>
                <Settings size={16} className="me-2" />
                Settings
              </Dropdown.Item>
              <Dropdown.Item onClick={onLogout}>
                <LogOut size={16} className="me-2" />
                Log out
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </Navbar>
  );
};

export default DashboardNavbar; 